<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<section class="print-settings-container">
  <div [ngClass]="name">
    <button
      type="button"
      class="xrx-btn btn-secondary btn medium icon-button"
      (click)="openModal($event)">
      @if (name && showIcon) {
        <span
          class="xrx-icon-sm"
          [ngClass]="name === 'language' ? 'globe' : param.icon"></span>
      }
      @if (label) {
        <span class="label sm-up" [xdaTranslate]="label"></span>
      }
      <span class="key sm-up" [xdaTranslate]="selectedValue.key"></span>
      <div class="xs label" [xdaTranslate]="label"></div>
      <div class="xs key" [xdaTranslate]="selectedValue.key"></div>
    </button>
  </div>
</section>
